export class Constant {

  public static readonly MAX_FILE_UPLOAD_SIZE_MB = 4;
  public static readonly MAX_FILE_UPLOAD_SIZE_BYTES = this.MAX_FILE_UPLOAD_SIZE_MB * 1024 * 1024;

  public static readonly USERNAME_MAX_LENGTH = 12;


  public static readonly TABLET_WIDTH = 991;
  public static readonly MOBILE_WIDTH = 767;

  private static readonly isBrowser = (typeof window !== 'undefined' && typeof window.document !== 'undefined');

  public static isTablet: () => boolean = () => (this.isBrowser && (window.innerWidth <= this.TABLET_WIDTH));
  public static isMobile: () => boolean = () => (this.isBrowser && (window.innerWidth <= this.MOBILE_WIDTH));

  public static isDev: () => boolean = () => (this.isBrowser &&  (window.location?.hostname === 'localhost'));
}
